export default class SupplierForm {

  constructor() {
    $('.supplier-form__form-switch-button').on('click', function(e) {
      e.preventDefault();
      $('.supplier-form__form-switch-button').removeClass('active');
      $(this).addClass('active');
      $('.supplier-form__form').removeClass('active');
      $($(this).attr('href')).addClass('active');

      $('.application-type-list-target').empty();
      $('.application-type input[type="checkbox"]').attr('checked', false);
    });

    $('.application-type input[type="checkbox"]').on('change', function() {
      if( $(this).val() &&  $('[data-application-type="'+$(this).val()+'"]').length ) {
        $('.application-type-list-target').html( $('[data-application-type="'+$(this).val()+'"]').html() );
      }
    });
  }

}



// WEBPACK FOOTER //
// ./scripts/blocks/supplier-form.js